import { useCustomerApplicationsRetrieveSuspense } from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect, useRouter } from "@tanstack/react-router"

import { SummaryCard } from "@/components/summary/SummaryCard"
import { store } from "@/lib/store"

export const Route = createFileRoute(
  "/_dashboard/applications/$applicationUuid/summary",
)({
  component: RouteComponent,
  loader: () => {
    const activeCompanyUuid = store.getState().activeCompanyUuid
    if (!activeCompanyUuid) {
      throw redirect({ to: "/" })
    }

    return { companyUuid: activeCompanyUuid }
  },
})

function RouteComponent() {
  const { companyUuid } = Route.useLoaderData()
  const { applicationUuid } = Route.useParams()
  const router = useRouter()

  const { data: application } = useCustomerApplicationsRetrieveSuspense(
    companyUuid,
    applicationUuid,
  )

  const handleBack = () => {
    if (router.history.canGoBack()) {
      router.history.back()
    } else {
      router.navigate({ to: "/" })
    }
  }

  return (
    <SummaryCard
      companyUuid={companyUuid}
      application={application}
      handleBack={handleBack}
    />
  )
}
